"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceFormat = void 0;
const data_type_1 = require("../data/data-type");
const config_name_1 = require("./config-name");
const config_type_1 = require("./config-type");
/**
 * Defines the Configurations available under the PriceFormat table.
 */
class PriceFormat extends config_name_1.ConfigName {
    constructor(_name, _returnType) {
        super(_name, _returnType);
    }
    getConfigType() {
        return config_type_1.ConfigType.PRICE_FORMAT;
    }
    getReturnType() {
        return this._returnType;
    }
}
exports.PriceFormat = PriceFormat;
/**
 * Customizes how the currency symbol and pattern is being displayed.
 */
PriceFormat.CURRENCY_FORMAT = new PriceFormat('currency_format', data_type_1.DataType.CONFIGURATION_DATA);
/**
 * Customizes the currency symbol prefix.
 */
PriceFormat.SYMBOL_PREFIX = new PriceFormat('symbol_prefix', data_type_1.DataType.STRING);
/**
 * Override the currency symbol position
 */
PriceFormat.CURRENCY_SYMBOL_POSITION = new PriceFormat('currency_symbol_position', data_type_1.DataType.ENUM);
/**
 * Customizes the trailing zero display configuration.
 */
PriceFormat.TRAILING_ZERO_DISPLAY = new PriceFormat('trailing_zero_display', data_type_1.DataType.ENUM);
//# sourceMappingURL=price-format.js.map